<template>
  <div>
    <div class="head">
      <!-- <div class="iconfont icon-mail leftFont"></div>
      <div class="iconfont icon-translation rightFont"></div> -->
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  name: 'Head',
}
</script>
<style scoped>
.head {
  height: 5.4375rem;
}
.leftFont {
  float: left;
  width: 2.1875rem;
  height: 1.71875rem;
  font-size: 2.1875rem;
  margin: 0rem .40625rem;
  display: table-cell;
  vertical-align: middle;
  padding-top: 1.890625rem;
  text-align: center;
}
.rightFont {
  float: right;
  width: 2.1875rem;
  font-size: 2.1875rem;
  height: 1.71875rem;
  margin: 0 .40625rem;
  display: table-cell;
  padding-top: 1.890625rem;
  vertical-align: middle;
  text-align: center;
}
</style>
